// extracted by mini-css-extract-plugin
export default {"section":"section_section__bgwoB","entry":"section_entry__gt5z3"};